import { BrandKey } from "@cerberus/branding";
import { ModuleId } from "./types";

/**
 * Default set of enabled modules per brand. Used when a deployment does not
 * provide an explicit module list. Keep in sync with the backend
 * `ModuleCatalog.DefaultsForBrand`.
 */
export const DEFAULT_MODULES_BY_BRAND: Record<BrandKey, ModuleId[]> = {
  th: [
    "headache-questionnaire",
    "patient-self-signup",
    // Capability modules default ON for TeleHeadache (its feature set is unchanged)...
    "questionnaires",
    "medication-refills",
    "billing",
    "out-of-area-interest",
    "provider-calendar",
    "patient-treatments",
    "patient-visits",
  ],
  // ...and OFF for the memory-care brand — both the legacy `mtc` key and the new `cerebralinked`
  // key: questionnaires, medication refills, billing, out-of-area interest, provider calendar, and
  // the patient treatments/visits tabs are all hidden. (mtc is retired at CerebraLinked cutover.)
  // partner-infusions is the inverse: the WeInfuse integration is memory-care-only.
  mtc: [
    "partner-infusions",
    "external-providers",
    "infusions",
    "clinic-locations",
    "caregivers",
  ],
  cerebralinked: [
    "partner-infusions",
    "external-providers",
    "infusions",
    "clinic-locations",
    "caregivers",
  ],
};
